import { useState, useEffect } from 'react';
import { WidgetSettings, DEFAULT_SETTINGS } from './types';
import { CustomizerPanel } from './components/CustomizerPanel';
import { PreviewPanel } from './components/PreviewPanel';
import { BookOpen, ExternalLink } from 'lucide-react';

function App() {
  const [settings, setSettings] = useState<WidgetSettings>(DEFAULT_SETTINGS);
  const [currentDevice, setCurrentDevice] = useState<'desktop' | 'mobile'>('desktop');

  // URLパラメータから設定を読み込み（localStorageは使用しない）
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const configParam = urlParams.get('config');
    
    if (configParam) {
      try {
        const decodedConfig = JSON.parse(atob(configParam));
        setSettings({ ...DEFAULT_SETTINGS, ...decodedConfig });
      } catch (error) {
        // 設定の読み込みに失敗
      }
    }
    // localStorageからの読み込みは削除
  }, []);

  // localStorageへの保存は削除

  const handleSettingsChange = (newSettings: WidgetSettings) => {
    setSettings(newSettings);
  };

  const handleDeviceChange = (device: 'desktop' | 'mobile') => {
    // App: デバイス変更
    setCurrentDevice(device);
  };


  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* ヘッダー */}
      <header className="bg-white border-b border-gray-200 px-6 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-gray-900">
              チャットボットUIカスタマイザー
            </h1>
          </div>
          
          <div className="flex items-center space-x-4">
            <a
              href="/manual.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition-colors"
            >
              <BookOpen className="w-4 h-4 mr-2" />
              使い方マニュアル
              <ExternalLink className="w-3 h-3 ml-1" />
            </a>
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <div className="flex-1 flex overflow-hidden">
        {/* カスタマイザーパネル */}
        <CustomizerPanel
          settings={settings}
          onSettingsChange={handleSettingsChange}
          onDeviceChange={handleDeviceChange}
        />

        {/* プレビューパネル */}
        <PreviewPanel
          settings={settings}
          currentDevice={currentDevice}
        />
      </div>

    </div>
  );
}

export default App;